import { useRef } from "react";

const swipeSensitivity = 80;
interface UseSwitchOnSwipeProps {
  switchLeft: () => void;
  switchRight: () => void;
}

export const useSwitchOnSwipe = ({ switchLeft, switchRight }: UseSwitchOnSwipeProps) => {
  const touchStartX = useRef<number | null>(null);
  const touchStartY = useRef<number | null>(null);
  const touchEndX = useRef<number | null>(null);
  const touchEndY = useRef<number | null>(null);

  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.changedTouches[0].screenX;
    touchStartY.current = e.changedTouches[0].screenY;
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    touchEndX.current = e.changedTouches[0].screenX;
    touchEndY.current = e.changedTouches[0].screenY;
  };

  const handleTouchEnd = () => {
    if (
      touchStartX.current !== null &&
      touchEndX.current !== null &&
      touchStartY.current !== null &&
      touchEndY.current !== null
    ) {
      const deltaX = touchStartX.current - touchEndX.current;
      const deltaY = touchStartY.current - touchEndY.current;

      // Only trigger if horizontal movement is greater than vertical movement
      if (Math.abs(deltaX) > 2 * Math.abs(deltaY) && Math.abs(deltaX) > swipeSensitivity) {
        if (deltaX > 0) {
          // Swiped left
          switchRight();
        } else {
          // Swiped right
          switchLeft();
        }
      }
    }
    // Reset touch positions
    touchStartX.current = null;
    touchStartY.current = null;
    touchEndX.current = null;
    touchEndY.current = null;
  };

  return {
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd
  };
};
